export const ACTION_TRIGGERS = ['image', 'button']

export const ACTION_KINDS = ['none', 'url', 'email']

const capitalized = (trigger) => trigger.charAt(0).toUpperCase() + trigger.slice(1)

const fieldFor = (trigger, field) => `${trigger}Action${capitalized(field)}`

const text = (value) => String(value ?? '').trim()

export function actionOf(announcement, trigger) {
    const actions = announcement?.actions ?? []

    return actions.find((action) => action.trigger === trigger) ?? null
}

export function actionActs(action) {
    if (action?.kind === 'email') {
        return true
    }

    return action?.kind === 'url' && text(action.url) !== ''
}

export function resolveActionFormValues(actions) {
    const stored = actions ?? []

    return ACTION_TRIGGERS.reduce((values, trigger) => {
        const action = stored.find((one) => one.trigger === trigger)

        return {
            ...values,
            [fieldFor(trigger, 'kind')]: action?.kind ?? 'none',
            [fieldFor(trigger, 'url')]: action?.url ?? '',
            [fieldFor(trigger, 'name')]: text(action?.name) || trigger,
        }
    }, {})
}

export function resolveActionsData(values) {
    return ACTION_TRIGGERS.map((trigger) => ({
        trigger,
        kind: values[fieldFor(trigger, 'kind')] ?? 'none',
        url: values[fieldFor(trigger, 'url')] ?? '',
        name: text(values[fieldFor(trigger, 'name')]) || trigger,
    }))
}
